/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Toast_Posture_SavedInputs */



/**
* | output |
* | --- |
* | "Posture updated." |
*
* @param {Rights_Tools_Toast_Posture_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_toast_posture_saved = /** @type {((inputs?: Rights_Tools_Toast_Posture_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Toast_Posture_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Positur aktualisiert.")
	return /** @type {LocalizedString} */ ("Posture updated.")
});